<template>
  <div class="outer">
    <h2>Manage Votes</h2>
    <div
      class="alert alert-info"
      role="alert"
      v-if="getFbId == -1"
    >You must login in via Facebook to manage votes.</div>
    <div v-else>
      <b-container>
        <div
          no-gutters
          v-for="disp in getLocalVotes"
          v-bind:key="disp.display.displayid"
          class="row display-row"
        >
          <div class="col-1 trash-div">
            <img
              class="trash-icon"
              title="Delete"
              alt="Delete"
              src="@/assets/trash.png"
              @click="localRemove(disp.type)"
            />
          </div>
          <div class="col-1">{{disp.label}}</div>
          <div class="col-9 title-div">
            <router-link
              :to="{ name: 'details', params: { id: disp.display.displayid }}"
            >{{disp.display.title}}</router-link>
          </div>
        </div>
      </b-container>
      <b-container class="labels">
        <b-row>
          <div class="col-3 icon-label">🎵</div>
          <div class="col-8 icon-description">Musical Display</div>
        </b-row>
        <b-row>
          <div class="col-3 icon-label">💡</div>
          <div class="col-8 icon-description">Static Display</div>
        </b-row>
      </b-container>
    </div>

    <div class="facebook">
      <Facebook />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Facebook from "./Facebook.vue";

export default {
  name: "RemoveVotes",
  components: {
    Facebook
  },
  methods: {
    ...mapActions(["fetchState", "removeVote"]),
    localRemove(type) {
      // Analytics?
      this.removeVote({type:type});
    }
  },
  computed: {
    ...mapGetters(["getFbId", "getVotedDisplays"]),
    getLocalVotes() {
      let rc = [];
      let v = this.getVotedDisplays;
      if (v.KY.displayid != -1) {
        rc.push({
          type: "KY",
          label: "KY",
          display: v.KY
        });
      }
      if (v.IN.displayid != -1) {
        rc.push({
          type: "IN",
          label: "IN",
          display: v.IN
        });
      }
      if (v.OH.displayid != -1) {
        rc.push({
          type: "OH",
          label: "OH",
          display: v.OH
        });
      }
      if (v.musical.displayid != -1) {
        rc.push({
          type: "musical",
          label: "🎵",
          display: v.musical
        });
      }
      if (v.static.displayid != -1) {
        rc.push({
          type: "static",
          label: "💡",
          display: v.static
        });
      }
      return rc;
    }
  },
  created() {
    this.fetchState();
  }
};
</script>
<style scoped>
h2 {
  color: darkred;
}
.facebook {
  margin-top: 1.5em;
  margin-bottom: 1em;
}
.trash-icon {
  height: 1em;
  cursor: pointer;
}
.title-div {
  text-align: left;
}
.trash-div {
  text-align: right;
}
.display-row {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.votes-avail {
  margin-top: 1em;
}
.icon-label {
  text-align: right;
}
.icon-description {
  text-align: left;
}
.labels {
  margin-top: 1.5em;
}
</style>
